import Vue from 'vue'
import VueResource from 'vue-resource'
import BootstrapVue from 'bootstrap-vue'
import NumberInput from '../../component/dccore-form/numberInput.vue'
import toastr from '../toastr'

if ($('#company_show').length) {
  Vue.use(VueResource)
  Vue.use(BootstrapVue)
  new Vue({
    el: '#company_show',
    components: { NumberInput },
    data () {
      return {
        clients: window.companyClients || [],
        selectedAll: false,
        selectedClients: [],
        moneybox: undefined
      }
    },
    computed: {
      disabled() {
        return this.selectedClients.length === 0
      },
      selectedClientIds() {
        return this.selectedClients.map(client => client.id)
      }
    },
    methods: {
      selectAll() {
        this.selectedAll = !this.selectedAll
        this.selectedClients = this.selectedAll ? this.clients : []
      },
      select(client) {
        const _client = this.selectedClients.find(el => el.id === client.id)

        if (_client) {
          this.selectedClients = this.selectedClients.filter(el => el.id !== _client.id)
        } else {
          this.selectedClients.push(client)
        }
      },
      clientSelected(client) {
        return this.selectedClients.filter(el => el.id === client.id).length > 0
      },
      topup() {
        this.$refs.topupModal.show()
      },
      save() {
        this.loading++

        let url = Routing.generate('api_company_client_moneybox', {
          moneybox: this.moneybox,
          ids: this.selectedClientIds
        })

        this.$http.post(url).then(() => {
          toastr.success(Translator.trans('form.updated'))
          this.moneybox = undefined
          this.loading--
        }, () => {
          toastr.error(Translator.trans('form.error'))
          this.loading--
        })
      }
    }
  })
}
